import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Footer() {

  return (
    <div className="footer">
      <style>
        {`
      .footer {
        width: 94%;
        background-color: #f8f9fa;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 40px 60px;
        flex-wrap: wrap; /* ✅ for mobile */
        box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
      }

      .footer-left {
        flex: 1;
        min-width: 250px;
      }

      .footer-left h2 {
        font-size: 24px;
        margin-bottom: 10px;
        color: #000;
      }

      .footer-left p {
        font-size: 14px;
        color: #555;
      }

      .footer-right {
        flex: 2;
        display: flex;
        justify-content: flex-end;
        gap: 80px;
        flex-wrap: wrap;
      }

      .footer-column {
        min-width: 150px;
      }

      .footer-column h4 {
        font-size: 18px;
        margin-bottom: 10px;
        color: #000;
      }

      .footer-column ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .footer-column ul li {
        font-size: 15px;
        color: #555;
        margin-bottom: 6px;
        cursor: pointer;
        transition: color 0.2s ease;
      }

      .footer-column ul li:hover {
        color: #FA4A0C;
      }

      /* 📱 Mobile Responsive */
      @media (max-width: 768px) {
        .footer {
          flex-direction: column;
          align-items: flex-start;
          padding: 30px 20px;
        }

        .footer-right {
          flex-direction: column;
          gap: 20px;
          width: 100%;
          margin-top: 20px;
        }

        .footer-column {
          min-width: 100%;
        }
      }
    `}
      </style>

      {/* Left Side - Logo / Company Info */}
      <div className="footer-left">
        <h2>Despatch Dost</h2>
        <p>We make local deliveries faster, easier, and smarter.</p>
      </div>

      {/* Right Side - Columns */}
      <div className="footer-right">
        <div className="footer-column">
          <h4>Policy</h4>
          <ul>
            <Link to={'/terms'} style={{ textDecoration: 'none' }}><li>Terms & Conditions</li></Link>
            <Link to={'/policy'} style={{ textDecoration: 'none' }}><li>Privacy Policy</li></Link>
            <Link to={'/refund'} style={{ textDecoration: 'none' }}><li>Refund Policy</li></Link>

          </ul>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <Link to={'/'} style={{ textDecoration: 'none' }}><li>Home</li></Link>
            {/* <li>Services</li> */}
            <Link to={'/aboutus'} style={{ textDecoration: 'none' }}><li>About</li></Link>
            <Link to={'/contactus'} style={{ textDecoration: 'none' }}><li>Contact</li></Link>
            <li></li>
          </ul>
        </div>
      </div>
    </div>

  )
}